import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var ArchiveIcon64Regular = forwardRefAndName('ArchiveIcon64Regular', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref,
      viewBoxSize: 64
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M29.5 12C28.6716 12 28 12.6716 28 13.5C28 14.3284 28.6716 15 29.5 15H32.5C33.3284 15 34 14.3284 34 13.5C34 12.6716 33.3284 12 32.5 12H29.5Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M24 17.5C24 16.6716 24.6716 16 25.5 16H28.5C29.3284 16 30 16.6716 30 17.5C30 18.3284 29.3284 19 28.5 19H25.5C24.6716 19 24 18.3284 24 17.5Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M29.5 20C28.6716 20 28 20.6716 28 21.5C28 22.3284 28.6716 23 29.5 23H32.5C33.3284 23 34 22.3284 34 21.5C34 20.6716 33.3284 20 32.5 20H29.5Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M24 25.5C24 24.6716 24.6716 24 25.5 24H28.5C29.3284 24 30 24.6716 30 25.5C30 26.3284 29.3284 27 28.5 27H25.5C24.6716 27 24 26.3284 24 25.5Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M36 39.3393C36 42.6336 33.0734 45.7143 29.4836 45.7143C25.8937 45.7143 23 42.6336 23 39.3393C23 36.8306 25.2085 32.1472 26.262 30.0558C26.5925 29.3998 27.2664 29 28.0009 29H30.8971C31.6678 29 32.3683 29.4395 32.689 30.1403C33.7429 32.444 36 37.5824 36 39.3393ZM32.5178 39.4465C32.5178 41.1133 31.1667 42.4644 29.5 42.4644C27.8332 42.4644 26.4821 41.1133 26.4821 39.4465C26.4821 37.7798 27.8332 36.4287 29.5 36.4287C31.1667 36.4287 32.5178 37.7798 32.5178 39.4465Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M11 16.5C11 10.701 15.701 6 21.5 6H42.5C48.299 6 53 10.701 53 16.5V47.5C53 53.299 48.299 58 42.5 58H21.5C15.701 58 11 53.299 11 47.5V16.5ZM21.5 9C17.3579 9 14 12.3579 14 16.5V47.5C14 51.6421 17.3579 55 21.5 55H42.5C46.6421 55 50 51.6421 50 47.5V16.5C50 12.3579 46.6421 9 42.5 9H29.9146C29.9699 9.15639 30 9.32468 30 9.5C30 10.3284 29.3284 11 28.5 11H25.5C24.6716 11 24 10.3284 24 9.5C24 9.32468 24.0301 9.15639 24.0854 9H21.5Z"
    }))
  );
});